/** The opportunity tier of a keyword, the server's rule in one client file.
 *
 *  Copied from internal/suggest/suggest.go (OpportunityCategory,
 *  OpportunityScore). The research and dashboard answers carry the server's
 *  tier already and are shown as given; this is for the keyword table, which
 *  only has the latest snapshot's popularity and difficulty. If the Go rule
 *  changes, change this with it — `opportunity.test.ts` pins the boundaries.
 *
 *  The old keyword cards had their own copy (`opportunityLabel` in
 *  AppDetail.tsx) with the same thresholds; it returned no badge where the
 *  server says `unscored`. The dashboard's opportunity list is a different
 *  thing: gaps read from the store (keywordGap in aso_handlers.go), which take
 *  no tier. */

import type { Opportunity } from '@/api/client'

export function opportunityTier(popularity: number, difficulty: number): Opportunity {
  if (popularity <= 0 && difficulty <= 0) return 'unscored'
  if (popularity >= 40 && difficulty <= 40) return 'golden'
  if (popularity >= 20 && popularity < 40 && difficulty <= 30) return 'hidden_gem'
  if (popularity >= 40 && difficulty > 40) return 'competitive'
  return 'low_value'
}

/** Popularity weighs more than ease: a keyword nobody searches is worth
 *  nothing however easy it is. Same weights as the server. */
export function opportunityScore(popularity: number, difficulty: number): number {
  return popularity * 0.6 + (100 - difficulty) * 0.4
}

/** What each tier means, for a pill's title. */
export const OPPORTUNITY_MEANING: Record<Opportunity, string> = {
  golden: '인기도 40 이상, 난이도 40 이하. 먼저 넣을 키워드다.',
  hidden_gem: '인기도 20~39, 난이도 30 이하. 검색은 적지만 쉽게 오른다.',
  competitive: '인기도 40 이상, 난이도 40 초과. 메타데이터와 리뷰가 받쳐야 오른다.',
  low_value: '찾는 사람이 확인되지 않았다. 보통 미뤄도 된다.',
  unscored: '인기도와 난이도를 아직 재지 않았다.',
}
